import { BodyText } from '@farol-ds/react'

import { LoginCard } from '../../login-card'

export const ConfirmEmailChangeStatus = {
  PROCESSING: 'processing',
  SUCCESS: 'success',
  ERROR: 'error',
} as const

export type ConfirmEmailChangeStatus =
  (typeof ConfirmEmailChangeStatus)[keyof typeof ConfirmEmailChangeStatus]

export interface ConfirmEmailChangeProps {
  status: ConfirmEmailChangeStatus
  email?: string | null
}

const PROCESSING_MESSAGE = 'Processando...'
const ERROR_MESSAGE = 'Não foi possível confirmar a alteração de e-mail.'

function getFeedback({ status, email }: ConfirmEmailChangeProps): string {
  if (status === ConfirmEmailChangeStatus.PROCESSING) return PROCESSING_MESSAGE
  if (status === ConfirmEmailChangeStatus.ERROR) return ERROR_MESSAGE
  return email ? `Seu e-mail foi alterado para ${email}.` : 'Seu e-mail foi alterado com sucesso.'
}

export function ConfirmEmailChange(props: ConfirmEmailChangeProps) {
  const header = { title: 'Confirmando seu novo e-mail' }

  return (
    <LoginCard header={header} hideCloseButton>
      <BodyText size="md">{getFeedback(props)}</BodyText>
    </LoginCard>
  )
}
